import React from 'react';
import { Button } from './Button';
import { useTranslation } from 'react-i18next';
import { getKombyAppUrl } from '../../config/kombyApp';

interface AuthButtonsProps {
  onNavigate?: (page: string) => void;
}

export const AuthButtons: React.FC<AuthButtonsProps> = ({ onNavigate }) => {
  const { t } = useTranslation('common');

  const handleSignIn = () => {
    window.open(getKombyAppUrl('auth'), '_blank', 'noopener,noreferrer');
  };

  const handleSignUp = () => {
    if (onNavigate) {
      onNavigate('pricing');
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Button 
        variant="ghost" 
        size="sm"
        data-testid="sign-in-button"
        onClick={handleSignIn}
        className="text-gray-700 dark:text-gray-300"
      >
        {t('auth.signIn')}
      </Button>
      <Button 
        variant="primary" 
        size="sm"
        data-testid="sign-up-button"
        onClick={handleSignUp}
      >
        {t('auth.signUp')}
      </Button>
    </div>
  );
};
